
import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    getUrlWithApiParams,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import {
    SHOP_PRICE_LIST_FAILURE,
    SHOP_PRICE_LIST_SUCCESS,
} from '../../redux/modules/shopPriceList/shopPriceList-actions';
import { getStringFromObject } from '../../constants/lodashUtils';


function* fetchShopPriceListWorker(action) {
    try {
        const {
            api,
            page,
            size,
            searchConstruct,
            filterValues,
        } = action;
        const includeInactive = getStringFromObject('includeInactive', filterValues, false);
        const searchString = getStringFromObject('searchText', filterValues, '');
        const urlWithApiWithParams = getUrlWithApiParams(api, {
            size, page, includeInactive, searchString,
        });
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.get, urlWithApiWithParams, searchConstruct);
        yield put({
            type: SHOP_PRICE_LIST_SUCCESS,
            data: {
                ...(response.data || {}),
            },
            page,
            size,
            filterValues,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Account invoices fetch failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: SHOP_PRICE_LIST_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchShopPriceListWorker;
